export const state = {
  notificationsList: [],
  total: 0,
  selectAllFlag: false
}
export const mutations = {
  setNotifications(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
      state.total = 0
    }
    state.notificationsList = response.data['data']
    state.total = response.data['header']['total']
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationsModules/notificationsMutation.js